/**
 * Posture Score weights — Prompt.md §17.
 *
 * "Tất cả weight phải configurable" — nên chúng ở đây, không ở trong công thức.
 */

import type { CameraPlacement, PostureMetricKey } from "@studystraight/shared-types";

export type ScoreWeights = Record<PostureMetricKey, number>;

export const defaultScoreWeights: Record<CameraPlacement, ScoreWeights> = {
  // §17: Head 40% / Torso 30% / Distance 20% / Shoulder 10%
  FRONTAL: { headAngle: 0.4, torsoAngle: 0.3, distanceRatio: 0.2, shoulderTilt: 0.1 },
  // Mode SIDE không quan sát được shoulderTilt → 0.1 của nó chuyển sang torso,
  // metric được đo trực tiếp và đáng tin nhất ở góc này.
  SIDE: { headAngle: 0.4, torsoAngle: 0.4, distanceRatio: 0.2, shoulderTilt: 0 },
};

/**
 * Phân loại điểm — §17.
 * `deltaToScore()` trong posture-core neo vào đúng các mốc này, nên đổi bảng ở đây mà không
 * đổi hàm kia sẽ làm hai bên lệch nhau.
 */
export const scoreBands = {
  excellent: 90,
  good: 75,
  needsAdjustment: 60,
} as const;
